<template>
 <div class="wd-container mt-0">
      <div class="container  mt-50">
        <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm">
            <div class="card">
            <article class="card-body">
                <img src="/img/icons/logo.png" alt="Los Angeles" style="width:50%;">
                <hr>
                <h5 class="card-title wd-login-header" style="margin-bottom:30px;">Login</h5>
                <div class="form-group">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-user"></i> </span>
                    </div>
                    <input name="" placeholder="Email" ref="email" v-model="userEmail" class="form-control" type="email"  v-on:keyup.enter="onLogin()">
                </div>
                </div>
                <div class="form-group">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                    </div>
                    <input class="form-control" placeholder="Password" type="password" ref="pass" v-model="userPassword"  v-on:keyup.enter="onLogin()">
                </div>
                </div>
                <div class="form-group">
                  <router-link to="/auth/password/reset" class="wd-link">Forget Password?</router-link>
                </div>
                <div class="clearfix"></div>
                <div class="form-group">
                <button type="submit" class="btn btn-login " v-on:click="onLogin"> Submit  </button>
                </div>
            </article>
            </div>
            </div>
            <div class="col-sm"></div>
        </div>
      </div>
 </div>
</template>

<script>
let R = [];
import CommonConstants from '@/constants/constants.js'
import Vue from 'vue';
import $ from 'jquery'
export default {
    name: 'Login',
    data() {
        return {
            constants: CommonConstants,
            userEmail: '',
            userPassword: '',
            roles_list: {
                executive: {
                    flag: false,
                    permissions: {jobs: true, accounts: true, timekeeping: true, reports: true, timesheet_approval: true}
                },
                accounting: {
                    flag: false,
                    permissions: {jobs: true, accounts: true, timekeeping: true, reports: true, timesheet_approval: true}
                },
                project_manager: {
                    flag: false,
                    permissions: {jobs: true, accounts: true, timekeeping: true, reports: true, timesheet_approval: true}
                },
                estimator: {
                    flag: false,
                    permissions: {jobs: true, accounts: true, timekeeping: true, reports: true, timesheet_approval: true}
                },
                foreman: {flag: false, permissions: {timekeeping: true}},
                time_entry: {
                    flag: false,
                    permissions: {jobs: true, accounts: true, timekeeping: true, reports: true, timesheet_approval: true}
                },
                admin: {
                    flag: false,
                    permissions: {jobs: true, accounts: true, timekeeping: true, reports: true, timesheet_approval: true}
                },
                salesman: {
                    flag: false,
                    permissions: {jobs: true, accounts: true, timekeeping: true, reports: true, timesheet_approval: true}
                },
            },
        }
    },
    beforeCreate: function () {
        if (this.$session.has('token')) {
          this.$router.push('/timesheets')
        }
    },
    methods: {
      /**
       * onLogin
       * Login with valid username and password
       */
      onLogin: function () {
        let self = this;
        this.error = []
        let flag = false;
        if (self.userEmail == '') {
          Vue.$toast.error('Please enter email', {
            position: 'top'
            });
            this.$refs['email'].focus()
          flag = true;
        }
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z])/;
        if (reg.test(self.userEmail) == false && flag == false) {
            Vue.$toast.error('Invalid email', {
            position: 'top'
            });
            this.$refs['email'].focus()
          flag = true;
        }
        if (self.userPassword == '' && flag == false) {
            Vue.$toast.error('Please enter password', {
            position: 'top'
            });
            this.$refs['pass'].focus()
          flag = true;
        }
        if (self.userPassword && self.userPassword.length <= 2 && flag == false) {
            Vue.$toast.error('Password length must be 2 or more characters', {
            position: 'top'
            });
            this.$refs['pass'].focus()
          flag = true;
        }
        if (!flag) {
            //storing remeber me information
          let request = {
            'email': self.userEmail,
            'password': self.userPassword
          }
          axios.post(self.constants.api_url + 'login', request)
            .then(function (result) {
              let response = result ;
              if (response.data.flag) {
                if(response.data.data.flag == 1){
                    if(self.rememberMe){
                       //store the email and password to remember in the browser
                      console.log("remember me enabled storing details");
                      localStorage.setItem('rememberUsername', self.userEmail);
                      localStorage.setItem('rememberPassword', self.userPassword);
                      localStorage.setItem('rememberMe', self.rememberMe);
                    }else if((!self.rememberMe) && localStorage.getItem('rememberMe')){
                      console.log("remember me disabled removing details");
                      localStorage.removeItem("rememberUsername");
                      localStorage.removeItem("rememberPassword");
                      localStorage.removeItem("rememberMe");
                    }
                axios.get(self.constants.api_url + 'timesheet/current', {headers: {token: response.data.data.data.token}})
                  .then(function (res) {
                    axios.get(self.constants.api_url + 'job/get/get_customfields',{headers : {token: response.data.data.data.token}})
                    .then(function(res){
                      localStorage.setItem('jobCustomfieldHeaders', JSON.stringify(res.data));
                      localStorage.setItem('cust1', res.data.company_custom_text1);
                      localStorage.setItem('cust2', res.data.company_custom_text2);
                      localStorage.setItem('cust3', res.data.company_custom_text3);
                      localStorage.setItem('cust_drop1', res.data.company_custom_drop_1);
                      localStorage.setItem('cust_drop2', res.data.company_custom_drop_2);
                      localStorage.setItem('cust_drop3', res.data.company_custom_drop_3);
                    })
                    .catch(function (error) {
                      })
                    self.$session.start()
                    self.$session.set('token', response.data.data.data.token)
                    localStorage.setItem('token', response.data.data.data.token);
                    axios.defaults.headers.common['token'] = self.$session.get('token');
                    self.$session.set('userData', JSON.stringify(response.data.data.data))
                    localStorage.setItem('userData', JSON.stringify(response.data.data.data));
                    let roles = response.data.data.data.roles;


                    for (let i = 0; i < roles.length; i++) {
                      if (roles[i].role_list != null) {
                        R.push(roles[i].role_list.slug)
                        self.roles_list[roles[i].role_list.slug].flag = true
                      }
                    }
                    localStorage.setItem('roles', JSON.stringify(response.data.data.data.roles));
                    localStorage.setItem('roleCheck', JSON.stringify(R));
                    localStorage.setItem('permissions', JSON.stringify(self.roles_list))

                    if (res.data.data.current_timesheet) {
                      localStorage.setItem('timesheet', JSON.stringify(res.data.data.current_timesheet))
                    } else {
                      localStorage.setItem('timesheet', '')
                    }
                    self.$router.push('/timesheets')
                    self.$router.go();
                  })
                  .catch(e => {

                  })
                }else{
                  self.$router.push('auth/reset/'+response.data.data.token+'/'+response.data.data.email)
                }
              } else {
                  Vue.$toast.error(response.data.message, {
                    position: 'top'
                 });
              }
            }).catch(function (error) {
                Vue.$toast.error(error, {
                position: 'top'
                });
          }).finally(function () {

          })
        } else {

        }
      }
    }
}
</script>

<style>

</style>
